export default class EngineStatusModel {
  constructor(item) {
    this.id = item?.id;
    this.vehiclename = item?.vehiclename;
    this.PlateNumber = item?.PlateNumber;
    this.event_time = item?.event_time;
    this.engine_event = item?.engine_event;
  }
}
